export default "__VITE_ASSET__513ee9f6__"